// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__OOT4h","info":"PatientInfo_info__fyFN4"};